<template>
    <div v-if='show_prerender_menu' >
        <a class='item-heading-text' v-for='heading in headings' :key="heading.id" :href="(heading.type == 'CU') ? heading.custom_url : `/${heading.sef_url}`">
            {{heading.name}}
            <div v-for='sub_heading in heading.sub_headings' :key='sub_heading.id'>
                <a :href='sub_heading.sef_url'>{{sub_heading.name}}</a>
                <div v-for='menu_item in sub_heading.menu_items' :key='menu_item.id'>
                    <a :href='menu_item.sef_url'>{{menu_item.name}}</a>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
export default {
    props: ['headings'],
    data(){
        return{
            show_prerender_menu: false
        }
    },
    mounted(){
        if(window.__PRERENDER_INJECTED){
            this.show_prerender_menu = true;
        }
    }
}
</script>